export default {
    RTTB: '滚动到底部'
}